import { useContext } from 'react';

import { FormContext } from '../context/Form';

export function useForm() {
  const context = useContext(FormContext);

  return context;
}
